import { render, staticRenderFns } from "./non-real-edit-card.vue?vue&type=template&id=6fe9719d&"
import script from "./non-real-edit-card.vue?vue&type=script&lang=ts&"
export * from "./non-real-edit-card.vue?vue&type=script&lang=ts&"
import style0 from "./non-real-edit-card.vue?vue&type=style&index=0&id=6fe9719d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports